export enum DocumentRequestStatus {
  InProgress,
  Processed,
  Rejected,
  Pending,
}
